import { IGroupsResponse } from '@joc/api-gateway';
import { Store } from 'redux/root';

export const selectorGetSmartGroupsAll = (store: Store): Array<IGroupsResponse> => {
	return store.smartGroupsRedux.smartGroups;
};
